import React, {forwardRef} from "react";
// core components
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles, TextField, InputAdornment } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  textField: {
    '& label.Mui-focused': {
      color: 'rgb(15, 25, 150)',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(15, 25, 150)',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'red',
      },
    }
  }
}))


export const TextInput = forwardRef((props, ref) => {
  // determina valor padrão dos atributos caso nenhum valor seja passado
  const maxLength = props.maxLength ? props.maxLength : 200
  const fieldsize = props.fieldsize ? props.fieldsize : 12
  const mobilesize = props.mobilesize ? props.mobilesize : 12
  const autocomplete = props.autoComplete ? props.autoComplete : "on"
  const endadornment = props.endadornment ? props.endadornment : null

  const classes = useStyles()
  return (
    <GridItem xs={mobilesize} sm={12} md={fieldsize}>
      <TextField className={classes.textField}
                 inputRef={ref}
                 fullWidth
                 inputProps={{ maxLength: maxLength, autoComplete: autocomplete}}
                 InputProps={{endAdornment: <InputAdornment position="start">{endadornment || ""}</InputAdornment>}}
                 {...props}/>
    </GridItem>
    )
})
